import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { MoreHorizontal, Edit, Trash2 } from "lucide-react";
import { Student } from "@/types/classroom";
import EditStudentDialog from "./EditStudentDialog";

interface StudentsTableProps {
  students: Student[];
  onDeleteStudent: (studentId: string) => void;
  onEditStudent: (studentId: string, data: { name: string }) => void;
}

const StudentsTable = ({
  students,
  onDeleteStudent,
  onEditStudent,
}: StudentsTableProps) => {
  const [editingStudent, setEditingStudent] = useState<Student | null>(null);

  return (
    <>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Email</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {students.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} className="text-center py-8 text-gray-500">
                No students added yet. Add a student using the form above.
              </TableCell>
            </TableRow>
          ) : (
            students.map((student) => (
              <TableRow key={student.workspace_id}>
                <TableCell>{student.name}</TableCell>
                <TableCell>{student.email}</TableCell>
                <TableCell className="text-right">
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="ghost" size="icon">
                        <MoreHorizontal className="h-4 w-4" />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end" className="w-[160px]">
                      <DropdownMenuItem
                        onClick={() => setEditingStudent(student)}
                      >
                        <Edit className="mr-2 h-4 w-4" />
                        Edit
                      </DropdownMenuItem>
                      <DropdownMenuItem
                        onClick={() => onDeleteStudent(student.workspace_id)}
                      >
                        <Trash2 className="mr-2 h-4 w-4" />
                        Delete
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>

      {editingStudent && (
        <EditStudentDialog
          student={editingStudent}
          isOpen={true}
          onOpenChange={(open) => !open && setEditingStudent(null)}
          onSubmit={(data) => {
            // Ensure all required properties are present
            onEditStudent(editingStudent.workspace_id, {
              name: data.name,
            });
            setEditingStudent(null);
          }}
        />
      )}
    </>
  );
};

export default StudentsTable;
